import React from 'react';
import {
  AuthProvider,
  ThemeProvider,
  SidebarProvider,
  SearchProvider,
  GroupsSidebarProvider,
  ProfileDrawerProvider,
  GroupGetStartedProvider,
  NodeProvider,
  FeatureFlagProvider,
} from 'context';
import { Router } from 'screens';
import { Apollo } from 'services';

export const RootProviders = (props: any) => {
  return (
    <Router>
      <ThemeProvider>
        <AuthProvider>
          <FeatureFlagProvider>
            <Apollo>
              <SidebarProvider>
                <SearchProvider>
                  <GroupsSidebarProvider>
                    <ProfileDrawerProvider>
                      <GroupGetStartedProvider>
                        <NodeProvider>{props.children}</NodeProvider>
                      </GroupGetStartedProvider>
                    </ProfileDrawerProvider>
                  </GroupsSidebarProvider>
                </SearchProvider>
              </SidebarProvider>
            </Apollo>
          </FeatureFlagProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
};
